const {
    MINIMUM_PERIODIC_CONTRIBUTION,
    CONTRIBUTION_PERIOD_MONTHLY,
    CONTRIBUTION_PERIOD_WEEKLY,
    CONTRIBUTION_PERIOD_DAILY,
    CONTRIBUTION_ISBAN_CODE_YEARLY,
    CONTRIBUTION_ISBAN_CODE_MONTHLY,
    CONTRIBUTION_ISBAN_CODE_WEEKLY,
    CONTRIBUTION_ISBAN_CODE_DAILY,
} = require('constants/RAConstants/index');

const FREQUENCY_MAP = {
    [CONTRIBUTION_ISBAN_CODE_YEARLY]: MINIMUM_PERIODIC_CONTRIBUTION,
    [CONTRIBUTION_ISBAN_CODE_MONTHLY]: CONTRIBUTION_PERIOD_MONTHLY,
    [CONTRIBUTION_ISBAN_CODE_WEEKLY]: CONTRIBUTION_PERIOD_WEEKLY,
    [CONTRIBUTION_ISBAN_CODE_DAILY]: CONTRIBUTION_PERIOD_DAILY,
};

export default {
    FREQUENCY_MAP,
    FULL_MONTH_DAYS: 30,
    FULL_YEAR_DAYS: 360,
    FIXED_DATA_POINTS: 36,
    FIXED_TIME_SPANS: 5,
    DATA_DATE_FORMAT: 'YYYY-MM-DD',
    EVOLUTION_SHOW_POINTS: 6,
    PROJECTION_SHOW_POINTS: [0, 7, 14, 21, 28, 35],
    PROJECTION_TOTAL_POINTS: 35,
    TICK_DISABLED_COLOR: '#E3E9E9',
    TICK_BUTTON_BORDER_COLOR: '#546E7A',
    TICK_TEXT_COLOR: '#69788C',
    LINE_LABEL_COLOR: '#002B45',
    LINE_STROKE_COLOR: '#333',
    DEFAULT_PORTFOLIO_QUANTITY: 1,
    REF_DOT_STROKE_COLOR: '#FFF',
    REF_DOT_FILL_COLOR: '#2DC4E0',
    REF_LINE_COLOR: '#69788C',
    OPACITY_HIDE: '0',
    OPACITY_SHOW: '1',
    TODAY_LABEL: 'hoy',
    OBJECTIVE_LABEL: 'objective',
    CURSOR_LINE_COLOR: '#536E7B',
    AXIS_LINE_COLOR: '#CDD6DB',
};
